import readyImg from '@/assets/images/extranetStatus/ready.png'
import faultImg from '@/assets/images/extranetStatus/fault.png'
import workingImg from '@/assets/images/extranetStatus/working.png'
import freeImg from '@/assets/images/extranetStatus/free.png'
import dayjs from "dayjs";

const logColumns = [
  {
    title: '事件',
    dataIndex: 'event',
    width: 150,
    scopedSlots: { customRender: 'event' }
  },
  {
    title: '消息',
    dataIndex: 'message',
    width: 225,
    scopedSlots: { customRender: 'message' }
  },
  {
    title: '时间',
    dataIndex: 'time',
    width: 150,
    scopedSlots: { customRender: 'time' }
  }
]

const listColumns = [
  {
    title: '设备编号',
    dataIndex: 'deviceCode',
    ellipsis: true,
    scopedSlots: { customRender: 'deviceCode' }
  },
  {
    title: '设备类型',
    dataIndex: 'deviceType',
    ellipsis: true,
    scopedSlots: { customRender: 'deviceType' }
  },
  {
    title: '所属客户',
    dataIndex: 'customer',
    ellipsis: true,
    scopedSlots: { customRender: 'customer' }
  },
  {
    title: '连接时间',
    dataIndex: 'operationTime',
    ellipsis: true,
    customRender:(time) => time ? dayjs(time).format('YYYY-MM-DD HH:mm:ss') : '',
    // scopedSlots: { customRender: 'operationTime' }
  },
  {
    title: '连接账户',
    dataIndex: 'diagnosticPerson',
    ellipsis: true,
    scopedSlots: { customRender: 'diagnosticPerson' }
  },
  {
    title: '连接类型',
    dataIndex: 'diagnosticType',
    ellipsis: true,
    customRender:(item) => extranetType[item],
    // scopedSlots: { customRender: 'diagnosticType' }
  },
  {
    title: '故障描述',
    dataIndex: 'faultDesc',
    ellipsis: true,
    scopedSlots: { customRender: 'faultDesc' }
  },
  {
    title: '处理意见',
    dataIndex: 'handleOpinion',
    ellipsis: true,
    scopedSlots: { customRender: 'handleOpinion' }
  }
]

const extranetStatusPic = {
  Ready: { name: '准备就绪', img: readyImg, textColor: '#4a90e2' },
  Fault: { name: '失败', img: faultImg, textColor: '#fa554c' },
  Working: { name: '工作中', img: workingImg, textColor: '#52c41a' },
  Free: { name: '空闲', img: freeImg, textColor: '#ffb818' }
}

const extranetType = {
  0: '生成连接码',
  1: '开始连接',
  2: '完成连接',
  3: '手动中止连接',
  4: '系统终止'
}

// 连接诊断服务器开启诊断的结果值
const diagnsisStatus = {
  0: '用户名/密码不正确,并未执行开启诊断动作',
  1: '验证超时,未执行开启诊断动作',
  2: '用户已登陆,未执行开启诊断动作',
  3: '发送登录信息后台未应答',
  4: '登录成功,但诊断失败(无效诊断码)',
  5: '登录成功,但诊断失败(Gateway不存在或离线)',
  6: '登录成功,但诊断失败(Gateway正在诊断中)',
  7: '超时,诊断服务器未回复;8:本地链路监听失败',
  8: '本地链路监听失败',
  9: '登录成功且开启诊断成功',
  10: '远程连接正在工作中',
  11: '平台设定参数有误',
  12: '链路传输协议不相同'
}

// 诊断服务器结束诊断的结果值
const endExtranetStatus = [
  '超时，诊断服务器未回复',
  '停止诊断成功',
  '当前不在诊断工作中，无法停止诊断'
]

// 诊断服务器返回的log结果值
const linkStatus = ['连接超时', '连接失败', '无效端口配置', '连接成功']
const listenStatus = ['监听失败', '保留', '无效端口配置', '监听成功']
const disconnectACKStatus = ['失败', '失败', '对端不存在', '断开连接成功']
const brokenStatus = ['后台服务与诊断服务器断开', '网关与诊断服务器断开']
const pingStatus = ['目标不可达', '失败', '失败', '成功']
const errStatus = ['失败次数过多,稍后再试', '对端链路不存在']

// 诊断通道表字段
const remoteConfigColumns = [
  {
    title: '外部地址',
    dataIndex: 'virtualIp',
    width: '150px',
    scopedSlots: { customRender: 'virtualIp' }
  },
  {
    title: '外部端口',
    dataIndex: 'virtualPort',
    width: '120px',
    scopedSlots: { customRender: 'virtualPort' }
  },
  {
    title: '内部地址',
    dataIndex: 'ip',
    width: '150px',
    scopedSlots: { customRender: 'ip' }
  },
  {
    title: '内部端口',
    dataIndex: 'port',
    width: '120px',
    scopedSlots: { customRender: 'port' }
  },
  {
    title: '传输层协议',
    dataIndex: 'protocol',
    width: '120px',
    scopedSlots: { customRender: 'protocol' }
  },
  {
    title: '用户层协议',
    dataIndex: 'appProtocol',
    width: '120px',
    scopedSlots: { customRender: 'appProtocol' }
  }
]

const extranetRecordColumns = [
  {
    title: '提交时间',
    dataIndex: 'operationTime',
    width: 150,
    scopedSlots: { customRender: 'operationTime' }
  },
  {
    title: '提交人',
    dataIndex: 'diagnosticPerson',
    width: 120,
    scopedSlots: { customRender: 'diagnosticPerson' }
  },
  {
    title: '连接类型',
    dataIndex: 'diagnosticType',
    width: 150,
    scopedSlots: { customRender: 'diagnosticType' }
  },
  {
    title: '故障描述',
    dataIndex: 'faultDesc',
    width: 150,
    scopedSlots: { customRender: 'faultDesc' }
  },
  {
    title: '处理意见',
    dataIndex: 'handleOpinion',
    width: 150,
    scopedSlots: { customRender: 'handleOpinion' }
  }
]

// 远程诊断日志类型
const ExtranetLogMap = {
  'Log.Connect.Request': {
    key: 'Log_Connect',
    title: '诊断软件连接请求',
    message: '{virtualiP}:{virtualport}连接请求'
  },
  'Log.onConnectACK.Request': {
    key: 'Log_onConnectACK',
    title: '诊断软件连接确认',
    message: '{virtualiP}:{virtualport}{result}'
  }, // 0:连接超时,1:连接失败,2:无效端口,3:连接成功
  'Log.Listern.Request': {
    key: 'Log_Listern',
    title: '监听端口请求',
    message: '反向请求监听{port}端口'
  },
  'Log.onListernACK.Request': {
    key: 'Log_onListernACK',
    title: '监听端口确认状态',
    message: '监听{port}端口结果为{result}'
  }, // 0:监听失败,1:保留,2:无效端口,3:监听成功
  'Log.Disconnect.Request': {
    key: 'Log_Disconnect',
    title: '诊断软件断开连接',
    message: '诊断软件{virtualiP}:{virtualport}主动关闭'
  },
  'Log.OnDisconnectACK.Request': {
    key: 'Log_OnDisconnectACK',
    title: '诊断软件断开连接确认',
    message: '诊断软件{virtualiP}:{virtualport}断开连接{result}'
  }, // 0:失败;1:失败;2:无效端口;3:成功
  'Log.OnDisconnect.Request': {
    key: 'Log_OnDisconnect',
    title: '后台服务被动关闭',
    message: '接收对端指令断开连接{virtualiP}:{virtualport}，断开连接诊断软件成功'
  },
  'Log.DisconnectACK.Request': {
    key: 'Log_DisconnectACK',
    title: '关闭连接确认动作',
    message: '{virtualiP}:{virtualport}断开连接成功'
  },
  'Log.onBroken.Request': { key: 'Log_onBroken', title: '链路局部中断', message: '{result}' }, // 后台服务与诊断服务器断开；1：网关与诊断服务器断开
  'Log.Ping.Request': { key: 'Log_Ping', title: 'Ping操作', message: 'ping{virtualiP}中' }, // 当前ping的链路虚拟ip
  'Log.onPingACK.Request': {
    key: 'Log_onPingACK',
    title: '回复Ping操作',
    message: 'ping{virtualiP}{result}'
  }, // 0:目标不可达;1:失败;2:失败;3:成功
  'Log.onError.Request': { key: 'Log_onError', title: '发生错误', message: '{errorCode}' } // 1失败次数过多,稍后再试 ,2 对端链路不存在
}

export {
  logColumns,
  extranetStatusPic,
  extranetType,
  diagnsisStatus,
  endExtranetStatus,
  linkStatus,
  listenStatus,
  disconnectACKStatus,
  brokenStatus,
  pingStatus,
  errStatus,
  remoteConfigColumns,
  extranetRecordColumns,
  ExtranetLogMap,
  listColumns
}
